import type { ComplaintCategory, ComplaintStatus } from '@zeus/index'
import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_CREATE_COMPLAINT, GQL_UPDATE_COMPLAINT } from '~/gql/complaints/complaints'

/** Saisie et traitement des entrées du registre (#325), avec leurs messages de retour. */
export function useComplaintActions(onDone: () => void) {
  const { t } = useTranslation()
  const [createComplaint, { loading: creating }] = useMutation(GQL_CREATE_COMPLAINT)
  const [updateComplaint, { loading: updating }] = useMutation(GQL_UPDATE_COMPLAINT)

  const run = async (action: () => Promise<unknown>, success: string) => {
    try {
      await action()
      toast.success(t(success))
      onDone()
    } catch {
      toast.error(t('complaints.saveFailed'))
    }
  }

  return {
    creating,
    updating,
    create: (input: { category: ComplaintCategory, subject: string, message: string }) =>
      run(() => createComplaint({ variables: { input } }), 'complaints.created'),
    update: (id: string, input: { category: ComplaintCategory, status: ComplaintStatus, response: string }) =>
      run(() => updateComplaint({ variables: { input: { id, ...input } } }), 'complaints.saved'),
  }
}
